<template>
  <Teleport to="body">
    <FreeModal
      :name="PROMOCODE_MODAL_NAME"
      with-light-blackout
      :container-style="modalContainerStyle"
      :body-style="modalBodyStyle"
    >
      <template #default="{ hide }">
        <div class="promocode-modal-content relative w-full max-w-[358px]">
          <button
            type="button"
            class="absolute right-2 top-3 z-20 flex h-6 w-6 items-center justify-center"
            :aria-label="t('common.close')"
            @click="hide"
          >
            <span
              class="bg-static-white flex h-6 w-6 items-center justify-center rounded-full shadow-md"
            >
              <CloseIcon />
            </span>
          </button>
          <div
            class="relative isolate mx-auto flex min-h-[220px] w-full max-w-[358px] flex-col justify-end overflow-hidden rounded-3xl bg-[#0D1419] px-4 pb-4 pt-4"
          >
            <img
              v-if="bannerImage"
              :src="bannerImage"
              alt=""
              role="presentation"
              class="absolute inset-0 -z-10 h-full w-full object-cover"
            />
            <CopyButton
              type="button"
              :text="promocode"
              class="text-static-white bg-static-white-muted relative z-20 mx-auto flex w-full max-w-[326px] items-center !justify-center gap-1 rounded-2xl px-3 py-2 text-sm font-semibold shadow-md"
              @onCopy="handleCopy"
            >
              <template #default>
                <span>{{ promocode }}</span>
              </template>
              <template #icon>
                <CopyIcon class="h-4 w-4 object-contain" />
              </template>
            </CopyButton>
          </div>
        </div>
      </template>
    </FreeModal>
    <div
      class="fixed bottom-16 left-4 z-[1000] flex w-[calc(100%-32px)] justify-center"
    >
      <FreeAlert ref="copyAlertRef" :duration="2000">
        <template #icon>
          <SuccessIcon />
        </template>
        <template #default>
          <p class="text-text-neutral-primary">
            {{ t('common.promocodeCopied') }}
          </p>
        </template>
      </FreeAlert>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { CopyButton, FreeAlert, FreeModal } from 'freedom-shared';

  import { PROMOCODE_MODAL_NAME } from '../config';
  import CloseIcon from '../assets/close-icon.svg?component';
  import CopyIcon from '../assets/copy-icon.svg?component';
  import SuccessIcon from '../assets/success-icon.svg?component';

  defineProps<{
    promocode: string;
    bannerImage?: string | null;
  }>();

  const { t } = useI18n();
  const copyAlertRef = ref<InstanceType<typeof FreeAlert>>();

  const modalContainerStyle = `
    --free-ui-modal-bg-color: transparent;
    --free-ui-modal-border-radius: 0;
    padding: 0;
    width: 100%;
    max-width: 358px;
    box-shadow: none;
  `;

  const modalBodyStyle = `
    overflow: visible;
    padding: 0;
  `;

  const handleCopy = () => {
    copyAlertRef.value?.show();
  };
</script>

<style scoped>
  .promocode-modal-content {
    animation: promocode-modal-enter 520ms ease-out;
    will-change: opacity;
  }

  @keyframes promocode-modal-enter {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>
